import moment from 'moment';
import PropTypes from 'prop-types';
import PropsType from 'props-type';
import { useMemo } from 'react';

import { DepositTransactionContent } from '@app/features/payment';

import './DepositTransactionItem.scss';

const propTypes = {
  timestamp: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  change: PropTypes.number.isRequired,
  balance: PropTypes.number.isRequired,
  description: PropTypes.string,
};

const defaultProps = {
  description: '',
};

type DepositTransactionItemProps = PropsType<typeof propTypes, typeof defaultProps>;

function DepositTransactionItem({
  timestamp,
  content,
  change,
  balance,
  description,
}: DepositTransactionItemProps) {
  const mappedContent = useMemo(() => {
    switch (content) {
      case DepositTransactionContent.PAY:
        return '요금제 구매';
      case DepositTransactionContent.PUT_ADMIN:
        return '예치금 충전(직접 입금)';
      case DepositTransactionContent.PUT_VBANK:
        return '예치금 충전(가상계좌 입금)';
      case DepositTransactionContent.REFUNDED:
        return '환불 금액 반환';
      case DepositTransactionContent.WITHDRAW:
        return '예치금 환불';
      default:
        return content;
    }
  }, [content]);

  return (
    <tr className="ResponsiveTable__row align-left" data-testid="deposit-transaction-row">
      <th className="ResponsiveTable__label-cell">일시</th>
      <td className="ResponsiveTable__value-cell DepositTransactionItem__timestamp">
        {moment(timestamp).format('LLL')}
      </td>
      <th className="ResponsiveTable__label-cell">내용</th>
      <td className="ResponsiveTable__value-cell">{mappedContent}</td>
      <th className="ResponsiveTable__label-cell">금액 / 잔액</th>
      <td className="ResponsiveTable__value-cell DepositTransactionItem__deposit-change align-right align-left-mobile">
        <b>{`${change > 0 ? '+' : '-'} ${Math.abs(change).toLocaleString()} 원`}</b>
        <br className="hidden-mobile" />
        <span className="DepositTransactionItem__deposit-balance">
          <span className="hidden display-mobile"> / </span>
          {`${balance.toLocaleString()} 원`}
        </span>
      </td>
      <th className="ResponsiveTable__label-cell">비고</th>
      <td className="ResponsiveTable__value-cell align-right align-left-mobile">{description}</td>
    </tr>
  );
}

DepositTransactionItem.propTypes = propTypes;
DepositTransactionItem.defaultProps = defaultProps;

export default DepositTransactionItem;
